import { render } from "./DetailPanel.vue?vue&type=template&id=3ec048fa&scoped=true"
import script from "./DetailPanel.vue?vue&type=script&lang=js"
export * from "./DetailPanel.vue?vue&type=script&lang=js"

import "./DetailPanel.vue?vue&type=style&index=0&id=3ec048fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ec048fa"

export default script